import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

/**
 * Hook para detectar versión de Android
 * Retorna null si no es Android, o el número de versión
 */
export function useAndroidVersion(): number | null {
  const [version, setVersion] = useState<number | null>(null);

  useEffect(() => {
    if (Capacitor.getPlatform() !== 'android') {
      setVersion(null);
      return;
    }

    // Obtener versión desde user agent
    const ua = navigator.userAgent;
    const match = ua.match(/Android\s(\d+)/);
    
    if (match) {
      setVersion(parseInt(match[1]));
    } else {
      setVersion(null);
    }
  }, []);

  return version;
}
